/**
 * O que dizer a quem não pode usar o Atendimento HUB: tudo nele exige
 * "Reportar problemas do Hub" (`can_report_system_issues`) no tipo de
 * usuário — sem ela o backend recusa com 403. Texto único para a tela de
 * "não liberado" e para o aviso do formulário.
 */
export const SYSTEM_ISSUES_NOT_ENABLED_MESSAGE =
  'Seu acesso não pode abrir chamados no Atendimento HUB. Peça ao administrador da sua empresa para liberar "Reportar problemas do Hub" no seu tipo de usuário.'
